export default __webpack_public_path__ + "static/media/elec-6.821aea7b.png";